var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "info-head spaceBetween" },
      [
        _c("span", [_vm._v("Business Verification")]),
        _vm._v(" "),
        _c("el-button", {
          attrs: {
            type: "text",
            icon: _vm.isOpen ? "el-icon-arrow-up" : "el-icon-arrow-down",
          },
          on: {
            click: function ($event) {
              _vm.isOpen = !_vm.isOpen
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isOpen,
            expression: "isOpen",
          },
        ],
      },
      [
        _vm.area != "HK"
          ? _c("OtherBusinessKYCInfo", {
              attrs: {
                Business: _vm.Business,
                Communication: _vm.Communication,
                Location: _vm.Location,
              },
              on: {
                "update:Business": function ($event) {
                  _vm.Business = $event
                },
                "update:business": function ($event) {
                  _vm.Business = $event
                },
                "update:Communication": function ($event) {
                  _vm.Communication = $event
                },
                "update:communication": function ($event) {
                  _vm.Communication = $event
                },
                "update:Location": function ($event) {
                  _vm.Location = $event
                },
                "update:location": function ($event) {
                  _vm.Location = $event
                },
              },
            })
          : _c("HKbusinessKYCInfo", {
              attrs: {
                Business: _vm.Business,
                Communication: _vm.Communication,
                Location: _vm.Location,
              },
              on: {
                "update:Business": function ($event) {
                  _vm.Business = $event
                },
                "update:business": function ($event) {
                  _vm.Business = $event
                },
                "update:Communication": function ($event) {
                  _vm.Communication = $event
                },
                "update:communication": function ($event) {
                  _vm.Communication = $event
                },
                "update:Location": function ($event) {
                  _vm.Location = $event
                },
                "update:location": function ($event) {
                  _vm.Location = $event
                },
              },
            }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }